import { Button } from '../../main/components/button'
import { decodeQueryString } from '../queryString'
import { encodeQueryString } from '../queryString'

function getTickersString(tickers: string[], tickersCount: number) {
  return Array.from({ length: Math.min(tickersCount, 6) })
    .map((_, index) => tickers[index] ?? tickers[tickers.length - 1])
    .join(',')
}

function getLayoutType(tickersCount: number) {
  switch (tickersCount) {
    case 0: // shouldn't happen
    case 1:
      return '1h1v'
    case 2:
      return '2h1v'
    case 3:
      return '3h1v'
    case 4:
      return '2h2v'
    case 5:
    default:
      // 6 and more
      return '3h2v'
  }
}

interface Props {
  isPremium: boolean
}

export function Fullscreen({ isPremium }: Props) {
  const { i, t, p = 'd', r } = decodeQueryString()
  const urlTickers = t.split(',')

  return (
    <Button
      as="a"
      size="regular"
      rounding="none"
      className="btn ml-1 flex items-center !px-3"
      leftContent="fullscreen"
      href={
        isPremium
          ? `/charts?${encodeQueryString({
              i,
              t: getTickersString(urlTickers, urlTickers.length),
              p: urlTickers.map(() => p).join(','),
              l: getLayoutType(urlTickers.length),
              r,
            })}`
          : `/elite.ashx?${encodeQueryString({
              utm_source: 'finviz',
              utm_medium: 'banner',
              utm_campaign: 'quote-fullscreen-button',
            })}`
      }
      target="_blank"
    >
      Fullscreen
    </Button>
  )
}
